module.exports = __webpack_public_path__ + "img/solution-pc-40.535d7fba.png";